import styles from "./ProductLabelsBase.module.scss";
import get from "lodash/get";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";

const ProductLabelsBase = ({product}) => {
  const labels = filter(get(product, "labels", []), (label) => {
    return !label.photo && label.type === 1;
  });

  if (isEmpty(labels)) {
    return "";
  }

  return (
    <div className={styles.labelsWrapper}>
      {map(labels, (label, index) => {
        const labelStyles = {};
        if (label.backgroundColor) {
          labelStyles.backgroundColor = label.backgroundColor;
        }

        if (label.textColor) {
          labelStyles.color = label.textColor;
        }

        return (
          <span className={styles.label} key={`base-label-${index}`} style={labelStyles}>
            {label.name}
          </span>
        )
      })}
    </div>
  );
}

export default ProductLabelsBase;